import { render, staticRenderFns } from "./ActiveInfo.vue?vue&type=template&id=5617ae4c&"
import script from "./ActiveInfo.vue?vue&type=script&lang=js&"
export * from "./ActiveInfo.vue?vue&type=script&lang=js&"
import style0 from "./ActiveInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports